import { Heading, Stack } from '@chakra-ui/react'
import type { Theme } from '@twlvxtwlv/types'
import { neueMachina } from '../../../../../fonts'

interface SectionTitleProps {
  title: string
  theme?: Theme
}

const styles = {
  light: {
    color: 'txtBlack',
  },
  dark: {
    color: 'txtWhite',
  },
}

export const SectionHeading = ({ title, theme }: SectionTitleProps) => {
  return (
    <Stack minW="full" px={[4, 4, 8, 12]}>
      <Heading
        as="h2"
        color={theme ? styles[theme].color : styles.light.color}
        fontFamily={neueMachina.style.fontFamily}
        fontWeight="100"
        size={{ base: 'md', md: 'xl' }}
        textTransform="uppercase"
      >
        {/* &#8627; equals ↳ */}
        &#8627; {title}
      </Heading>
    </Stack>
  )
}
